import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import EditDetailsForm from './form'

function EditDetailsModal ({ open, onClose, target }) {
  return (
    <SydModal open={open} onClose={onClose} title='Edit Details' size='medium'>
      {open ? (
        <EditDetailsForm target={target} onCancel={onClose} />
      ) : null}
    </SydModal>
  )
}

EditDetailsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  target: PropTypes.object
}

export default EditDetailsModal
